import type { LocationConsentStatus } from '@chukua/common';

/** The server derives the status from the driver's newest answer in the app (gitaumoses4/chukua#60); these only name it. */
export const CONSENT_LABELS: Record<LocationConsentStatus, string> = {
  not_asked: 'Not asked yet',
  foreground: 'While the app is open',
  background: 'Always, including in the background',
  withdrawn: 'Withdrawn',
};

export const CONSENT_COLORS: Record<LocationConsentStatus, string> = {
  not_asked: 'default',
  foreground: 'processing',
  background: 'success',
  withdrawn: 'error',
};

/** What the office should know about a status: why a driver may see no trip in the app. */
export const CONSENT_NOTES: Record<LocationConsentStatus, string> = {
  not_asked: "The driver hasn't answered in the app yet, so the app won't show them a trip.",
  foreground: 'Location is shared while the app is open.',
  background: 'Location is shared while driving, even with the app in the background.',
  withdrawn: "The driver has withdrawn consent, so the app won't show them a trip until they agree again.",
};
